import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  regionCountryChannel = new Subject();
  regionProvinceChannel = new Subject();
  regionCityChannel = new Subject();
  createChannel = new Subject();
  coupleChannel = new Subject();
  satkerGajiWebChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.satkerGajiWebChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "error fetch");
    }
  };

  fetchRegionCountry = async (query) => {
    try {
      this.regionCountryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCountry(query)
        .then((result) => {
          this.regionCountryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCountryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchRegionProvince = async (query) => {
    try {
      this.regionProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionProvince(query)
        .then((result) => {
          this.regionProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchRegionCity = async (query) => {
    try {
      this.regionCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCity(query)
        .then((result) => {
          this.regionCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchCouple = async (query) => {
    try {
      this.coupleChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCouple(query)
        .then((result) => {
          this.coupleChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.coupleChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchSatkerGajiWeb = async (query) => {
    try {
      this.satkerGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSatkerGajiWeb(query)
        .then((result) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default CreateBloc;
